import FormLayout from "src/layouts/FormLayout";
import { useAuth, useUser } from "src/context";

export default () => {
  const { logout } = useAuth();
  const { userData } = useUser();
  if (userData && confirm("Logout user?")) {
    void logout();
    alert("Logged out!");
  }
  return (
    <FormLayout
      title="Dummy Logout Page"
      subtitle="Not real, don't judge me"
      headerTitle="Firebase Auth Testing"
    >
      <h2>Log out</h2>
    </FormLayout>
  );
};
